import { RouteTable } from '../infrastructure/components/RenderRouteTable';

import { Login } from './Login';

export const authRoutes: RouteTable = [
  {location: '/login/:token?', component: Login, publicOnly: true, frame: 'legacy'},
];
